import { Injectable, WritableSignal, signal } from "@angular/core";
import { Params, Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Observable } from "rxjs";
import { AccountInfo } from "@azure/msal-browser";
import { MsalService } from "@azure/msal-angular";

@Injectable({
    providedIn: 'root',
})

export class AdminAuthService {

    jwtHelper = new JwtHelperService();

    public redirectUrl: string = '';
    public redirectUrlQueryParams: Params | null = null;

    constructor(private router: Router,
      private msalService: MsalService) {

    }

    public putAuthToken(token: AccountInfo | null){
      if (token) {
          localStorage.setItem("authToken", token!.idToken!);
      }
    }

    public getAuthToken(): string{
        let authToken = localStorage.getItem("authToken")!;

        if (authToken === "" || authToken === null) {
            let activeAccount = this.msalService.instance.getActiveAccount();

            this.putAuthToken(activeAccount);
            authToken = localStorage.getItem("authToken")!;
        }

        return authToken;
    }

    public isLoggedIn(){
        let token = this.getAuthToken();

        if(token != null && token != ''){
            return !this.jwtHelper.isTokenExpired(token);
        } else {
            return false;
        }
    }

    /**
    * Upon logout only clear items in local storage that are related to the current session
    */
    public clearLocalStorageAuthItems(): void {
        const authItems = ['authToken']
        authItems.forEach(item => localStorage.removeItem(item));
    }

    public logOut():Observable<any>{
        this.clearLocalStorageAuthItems();
        return new Observable<any>();
    }

    public hasUserRole(role: string): boolean{
        let rolesToSearch = this.getAllUserRolesFromToken();

        let results = rolesToSearch.some((roles: string) => roles === role);
        return results;
    }

    public getAllUserRolesFromToken(): string[] {
        const token = this.getAuthToken();
        const decodedToken = this.jwtHelper.decodeToken(token);
        let roles: string[] = [];

        if(!decodedToken)
            return [];

        const userRolePermissions: string[] = decodedToken?.roles;
        if (!userRolePermissions || userRolePermissions === undefined)
            return [];

        roles = userRolePermissions.map((str) => str.toLowerCase());

        return roles;
    }

    get preferredUsername(): string {
        const token = this.getAuthToken();
        const decodedToken = this.jwtHelper.decodeToken(token);
        if (decodedToken) {
          return decodedToken.preferred_username;
        }
        return '';
    }

    public setLandingPage() {
        const LANDING_PAGES_BY_ROLES: string[] = ['customerservice', 'cms'];
        let userRoles = this.getAllUserRolesFromToken();
        let landingPageFound: boolean = false;

        for (let i = 0; i < LANDING_PAGES_BY_ROLES.length; i++) {
            if (userRoles.some((role: string) => role === LANDING_PAGES_BY_ROLES[i])) {
                landingPageFound = true;

                let landingPageUrl: string = LANDING_PAGES_BY_ROLES[i] === 'cms' ? '/cms/templates' : LANDING_PAGES_BY_ROLES[i];
                this.router.navigate([landingPageUrl]);
                break;
            }
        };

        if (!landingPageFound) {
            this.router.navigate(['/unauthorized']);
        }
    }
}
